<div class="container">
    <div class="row d-flex flex-column-reverse flex-lg-row me-landing-page-image-text">
        <div class="col-md-6 col-xs-12 me-landing-page-image-text__block" [class.hero]="data.hero">
            <div tabindex="0" class="me-landing-page-image-text__title" [innerHTML]="data.headline | storyblokRichtext" [class.hero]="data.hero">
            </div>
            <div *ngIf="data.hero" class="me-landing-page-image-text__line"></div>
            <div tabindex="0" class="me-landing-page-image-text__description" [innerHTML]="data.text | storyblokRichtext" [class.hero]="data.hero"></div>
            <div class="me-landing-page-image-text__button">
                <div *ngIf="data.link.url != ''" class="me-landing-page-image-text__button_block">
                    <storyblok-link [classList]="'btn btn--primary'" [data]="data.link"></storyblok-link>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-xs-12">
            <div class="me-landing-page-image-text__image">
                <img src="{{data.image.filename}}" >
            </div>
        </div>
    </div>
</div>